import { render, staticRenderFns } from "./PopupAdmin.vue?vue&type=template&id=2c38b72a&"
import script from "./PopupAdmin.vue?vue&type=script&lang=js&"
export * from "./PopupAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PopupAdmin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports